export default {
  ACTIONS_USER_LOAD: 'ACTIONS_USER_LOAD',
  ACTIONS_USER_FETCHED: 'ACTIONS_USER_FETCHED',
};
